<template>
  <div class="news">
    <div class="container">
      <BackButton class="back-btn desktop" />
      <article>
        <PulseLoader class="loading"
                     :loading="state == 'loading'"
                     color="#f1d85b"
                     size="20px" />
        <ErrorView v-if="state == 'error'" />
        <NotFoundView v-if="state == 'notFound'" />
        <div v-if="state == 'display'">
          <div class="news-header">
            <NewsDate class="date"
                      :date="news.publish_date" />
            <div class="description">{{ news.short_description }}</div>
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentURL}`"
               target="_blank"
               class="share desktop">
              分享至facebook
            </a>
          </div>
          <Divider class="divider" />
          <div class="mobile-share">
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentURL}`"
               target="_blank"
               class="share mobile">
              分享至facebook
            </a>
          </div>
          <div class="news-content"
               v-html="news.content" />
          <div class="social desktop">
            <SocialLink class="link"
                        target="_blank"
                        :href="facebookUrl"
                        :icon="require('../assets/fb-white-icon.svg')"
                        color="#4868ae"
                        label="高僑文教Facebook"
                        description="<span>Facebook 粉絲專頁</span>" />
            <SocialLink class="link"
                        target="_blank"
                        href="https://line.me/R/ti/p/%40bzh1686u"
                        :icon="require('../assets/line-white-icon.svg')"
                        color="#00c100"
                        label="高僑文教Line"
                        description="<span>加入高僑Line</span></br><span> 提供諮詢及升學資訊</span>" />
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import { withApiClient } from "@/api/ApiClient.js";
import { NotFoundError } from "@/api/error.js";
import ErrorView from "@/components/ErrorView.vue";
import NotFoundView from "@/components/NotFoundView.vue";
import Divider from "@/components/Divider.vue";
import NewsDate from "@/components/NewsDate.vue";
import BackButton from "@/components/BackButton.vue";
import SocialLink from "@/components/SocialLink.vue";

const News = {
  components: {
    ErrorView,
    PulseLoader,
    NotFoundView,
    Divider,
    NewsDate,
    BackButton,
    SocialLink
  },
  data: function() {
    return {
      state: "idle",
      news: null,
      currentURL: window.location.href
    };
  },
  computed: {
    facebookUrl() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return "fb://page/?id=572806189534034";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        return "fb://page/572806189534034";
      } else {
        return "https://www.facebook.com/kaochiao23892887/";
      }
    }
  },
  mounted() {
    this.state = "loading";
    this.apiClient.fetchNews(this.$route.params.id).subscribe(
      resp => {
        this.state = "display";
        this.news = resp;
      },
      err => {
        if (err instanceof NotFoundError) {
          this.state = "notFound";
        } else {
          this.state = "error";
        }
      }
    );
  }
};

export default withApiClient(News);
</script>

<style lang="scss">
.news {
  .loading {
    text-align: center;
    margin: 30px;
  }

  .container {
    background: url("../assets/news-header.png") center top no-repeat;
    background-size: 100% auto;

    .back-btn {
      position: absolute;
      left: 20px;
      top: 120px;
    }

    article {
      margin: 0 auto 60px;
      max-width: 1024px;
      padding: 60px 0;
      position: relative;

      .news-header {
        display: flex;
        flex-direction: row;
        align-items: flex-end;

        .date {
          border-right: 2px solid #2b3c56;
          padding-right: 18px;
          margin-right: 26px;
        }
        .description {
          flex: 1;
          font-weight: bold;
          color: #343433;
          font-size: 20px;
          line-height: 28px;
          letter-spacing: 2.5px;
        }
        .share {
          margin-left: 25px;
          background-color: #63abcd;
          border-radius: 9px;
          color: white;
          padding: 0 12px;
          font-size: 14px;
          font-weight: bold;
          text-decoration: none;
          height: 38px;
          line-height: 38px;
          box-sizing: border-box;
        }
      }

      .divider {
        margin-top: 10px;
        margin-bottom: 27px;
      }

      .news-content {
        color: #595959;
      }

      .social {
        display: flex;
        justify-content: center;
        margin-top: 100px;

        .link {
          margin: 0 35px;
        }
      }
    }
  }
}

@media (max-width: 1023px) {
  .news {
    .container {
      padding-top: 20px;
    }

    .news-header {
      padding-bottom: 5px !important;

      .description {
        font-size: 16px !important;
      }
    }

    article {
      padding: 20px 10px !important;

      .news-content {
        img {
          width: 100%;
          height: auto;
        }
      }
    }

    .divider {
      margin: 5px 0 !important;
    }

    .mobile-share {
      display: flex;
      justify-content: center;

      .share {
        margin: 15px;
        background-color: #63abcd;
        border-radius: 9px;
        color: white;
        padding: 0 12px;
        font-size: 14px;
        font-weight: bold;
        text-decoration: none;
        height: 38px;
        line-height: 38px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
